/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SocietySocietyFormsInner } from './SocietySocietyFormsInner';
import {
    SocietySocietyFormsInnerFromJSON,
    SocietySocietyFormsInnerFromJSONTyped,
    SocietySocietyFormsInnerToJSON,
} from './SocietySocietyFormsInner';

/**
 * 
 * @export
 * @interface Society
 */
export interface Society {
    /**
     * 
     * @type {string}
     * @memberof Society
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof Society
     */
    internalIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof Society
     */
    readableName: string;
    /**
     * 
     * @type {string}
     * @memberof Society
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Society
     */
    website?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Society
     */
    portal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Society
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Society
     */
    address?: string | null;
    /**
     * 
     * @type {object}
     * @memberof Society
     */
    additionalTerritories?: object | null;
    /**
     * 
     * @type {Array<SocietySocietyFormsInner>}
     * @memberof Society
     */
    societyForms: Array<SocietySocietyFormsInner>;
    /**
     * 
     * @type {string}
     * @memberof Society
     */
    formEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Society
     */
    formPostalAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Society
     */
    formPortal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Society
     */
    formReminderFrequency?: SocietyFormReminderFrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof Society
     */
    formStopReminderFrequency?: SocietyFormStopReminderFrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof Society
     */
    formReminderSendTo?: string | null;
}


/**
 * @export
 */
export const SocietyFormReminderFrequencyEnum = {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Yearly: 'Yearly'
} as const;
export type SocietyFormReminderFrequencyEnum = typeof SocietyFormReminderFrequencyEnum[keyof typeof SocietyFormReminderFrequencyEnum];

/**
 * @export
 */
export const SocietyFormStopReminderFrequencyEnum = {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Yearly: 'Yearly'
} as const;
export type SocietyFormStopReminderFrequencyEnum = typeof SocietyFormStopReminderFrequencyEnum[keyof typeof SocietyFormStopReminderFrequencyEnum];


/**
 * Check if a given object implements the Society interface.
 */
export function instanceOfSociety(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "societyForms" in value;

    return isInstance;
}

export function SocietyFromJSON(json: any): Society {
    return SocietyFromJSONTyped(json, false);
}

export function SocietyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Society {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'internalIdentifier': json['internal_identifier'],
        'readableName': json['readable_name'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'website': !exists(json, 'website') ? undefined : json['website'],
        'portal': !exists(json, 'portal') ? undefined : json['portal'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'additionalTerritories': !exists(json, 'additional_territories') ? undefined : json['additional_territories'],
        'societyForms': ((json['society_forms'] as Array<any>).map(SocietySocietyFormsInnerFromJSON)),
        'formEmail': !exists(json, 'form_email') ? undefined : json['form_email'],
        'formPostalAddress': !exists(json, 'form_postal_address') ? undefined : json['form_postal_address'],
        'formPortal': !exists(json, 'form_portal') ? undefined : json['form_portal'],
        'formReminderFrequency': !exists(json, 'form_reminder_frequency') ? undefined : json['form_reminder_frequency'],
        'formStopReminderFrequency': !exists(json, 'form_stop_reminder_frequency') ? undefined : json['form_stop_reminder_frequency'],
        'formReminderSendTo': !exists(json, 'form_reminder_send_to') ? undefined : json['form_reminder_send_to'],
    };
}

export function SocietyToJSON(value?: Society | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'internal_identifier': value.internalIdentifier,
        'readable_name': value.readableName,
        'country': value.country,
        'website': value.website,
        'portal': value.portal,
        'phone': value.phone,
        'address': value.address,
        'additional_territories': value.additionalTerritories,
        'society_forms': ((value.societyForms as Array<any>).map(SocietySocietyFormsInnerToJSON)),
        'form_email': value.formEmail,
        'form_postal_address': value.formPostalAddress,
        'form_portal': value.formPortal,
        'form_reminder_frequency': value.formReminderFrequency,
        'form_stop_reminder_frequency': value.formStopReminderFrequency,
        'form_reminder_send_to': value.formReminderSendTo,
    };
}

